
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import Head from "next/head"

import SEO from "@/meta/SEO"
import { getHelpCenterArticleProps } from "@/organisms/HelpCenterArticle/functions/getHelpCenterArticleProps"
import HelpCenterArticle from "@/organisms/HelpCenterArticle/HelpCenterArticle"
import Help from "@/templates/Help/Help"

function HowItWorks() {
  const sectionsList = [
    ["what_is_fansi"],
    ["does_it_cost_to_have_fansi_account"],
    ["does_fansi_charge_commission_on_my_purchases"],
  ]

  const props = getHelpCenterArticleProps(
    "helpHowItWorks",
    "how_fansi_works",
    sectionsList
  )

  return (
    <div>
      <Head>
        <title>Centrum pomocy | fansi.pl</title>
        <SEO description="W Centrum Pomocy znajdziesz odpowiedzi na najczęściej zadawane pytania dotyczące platformy fansi, logowania oraz zakupu produktów od influencerów." />
        {/* <meta name="robots" content="noindex,nofollow" /> */}
      </Head>
      <HelpCenterArticle {...props} />
    </div>
  )
}

HowItWorks.Layout = Help
export default HowItWorks


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/help/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  